import { EventsRecords, SessionIdentity, Metadata } from '@samelogic/steps';
import * as Factory from 'factory.ts';
import { ElementEventProps } from '..';
import { IdentitySourceConfig, StepConfig, TriggerConfig, WorkflowConfig } from '../../models';
import { SessionManager } from '../../tracking';
import { Context } from '../Context';

export const triggerFactory = Factory.Sync.makeFactory<TriggerConfig>({
  event: 'ElementClick',
  cssSelector: '.some-css-selector'
} as ElementEventProps);

export const stepFactory = Factory.Sync.makeFactory<StepConfig>({
  uses: 'https://some-url',
  name: 'some-step-name',
  needs: {
    name: 'some-other-step',
    event: 'OnSubmit'
  }
});

export const identityFactory = Factory.Sync.makeFactory<IdentitySourceConfig>({
  identity: 'someData.someUser.email',
  properties: [
    {
      name: 'someProp',
      variable: 'someData.someUser.age'
    }
  ]
});

export const workflowFactory = Factory.Sync.makeFactory<WorkflowConfig>({
  name: 'some-trigger',
  triggers: triggerFactory.buildList(1),
  steps: stepFactory.buildList(2),
  identitySource: identityFactory.build()
});

export const contextMetadataFactory = Factory.Sync.makeFactory<Metadata>({
  name: 'some-workflow'
});

export const sessionIdentityFactory = Factory.Sync.makeFactory<SessionIdentity>({
  userId: 'test-user-id',
  sessionId: 'test-session-id'
});
export const workflowContextEventsFactory = Factory.Sync.makeFactory<EventsRecords>({
  'test-step': {
    'test-event': {
      data: {
        someData: 'test-data'
      }
    }
  }
});

export const contextFactory = Factory.Sync.makeFactory<Context>({
  identity: sessionIdentityFactory.build(),
  metadata: contextMetadataFactory.build(),
  events: workflowContextEventsFactory.build(),
  clone: () => {
    return new Context(
      new SessionManager('envId'),
      contextMetadataFactory.build(),
      workflowContextEventsFactory.build()
    );
  }
});
